import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { PaymentDetailVerification, PaymentProvider } from "@/types/payment";
import { PaymentMethodForm } from "@/components/host/payment-methods/PaymentMethodForm";
import { VerificationStatus } from "@/components/host/payment-methods/VerificationStatus";
import { useToast } from "@/hooks/use-toast";

const HostPaymentMethodsPage = () => {
  const [verifications, setVerifications] = useState<PaymentDetailVerification[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();
  const [hostId, setHostId] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserAndVerifications = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user?.id) return;
        
        setHostId(session.user.id);
        
        const { data, error } = await supabase
          .from("payment_detail_verifications")
          .select("*")
          .eq("host_id", session.user.id);

        if (error) throw error;

        const transformedData: PaymentDetailVerification[] = data.map(item => ({
          id: item.id,
          hostId: item.host_id,
          phoneNumber: item.phone_number,
          provider: item.provider as PaymentProvider,
          status: item.status,
          verifiedAt: item.verified_at,
          createdAt: item.created_at,
          updatedAt: item.updated_at,
          mtnAccountHolder: item.mtn_account_holder,
          mtnAccountType: item.mtn_account_type,
          kycStatus: item.kyc_status,
          kycVerifiedAt: item.kyc_verified_at,
          kycRejectionReason: item.kyc_rejection_reason,
          riskScore: item.risk_score
        }));

        setVerifications(transformedData);
      } catch (error) {
        console.error("Error fetching verifications:", error);
        toast({
          title: "Error",
          description: "Failed to load payment verifications",
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndVerifications();
  }, [toast]);

  const handleSubmit = async (data: any) => {
    // Handle form submission logic here
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Payment Methods</h1>
      
      {verifications.map((verification) => (
        <div key={verification.id} className="mb-6">
          <VerificationStatus 
            hostId={verification.hostId}
            verification={verification}
          />
        </div>
      ))}

      {hostId && (
        <div className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Add New Payment Method</h2>
          <PaymentMethodForm 
            onSubmit={handleSubmit}
            isLoading={loading}
          />
        </div>
      )}
    </div>
  );
};

export default HostPaymentMethodsPage;